import {i18n} from '~ui/components/AsideNavigation/i18n';

import {makeEpic, PAGE_SIZE, toBookmarksOrderBy} from '../common';

import {actions} from './slice';
import {AutoBookmarkTypeFilter} from './types';

const autoBookmarksEpicTypes = [
    actions.init.type,
    actions.setQueryFilter.type,
    actions.setTypeFilter.type,
    actions.loadNextPage.type,
    actions.changeOrder.type,
];

export const autoBookmarksEpic = makeEpic(
    (state) => state.autoBookmarks,
    (state, {sdk}) =>
        sdk.wiki.getAutoBookmarks({
            cursor: state.nextCursor ? state.nextCursor : undefined,
            pageSize: PAGE_SIZE,
            orderBy: toBookmarksOrderBy(state.orderBy),
            orderDirection: state.orderDirection,
            query: state.filters.query,
            bookmarkType:
                state.filters.type === AutoBookmarkTypeFilter.All ? undefined : state.filters.type,
        }),
    actions,
    autoBookmarksEpicTypes,
    i18n('created-and-edited-error'),
);
